import { SET_ALERT, REMOVE_ALERT } from "../types";

const initialState = [];

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_ALERT:
            if (payload.alertCode) {
                const existingAlert = state.find(
                    alert => alert.alertCode === payload.alertCode
                );
                if (existingAlert) {
                    return state.map(alert =>
                        alert.alertCode === payload.alertCode
                            ? { ...alert, ...payload, alertId: existingAlert.alertId }
                            : alert
                    );
                }
            }
            return [...state, payload];
        case REMOVE_ALERT:
            return state.filter(alert => alert.alertId !== payload);
        default:
            return state;
    }
}
